// extracted by mini-css-extract-plugin
export var active = "_gx-7";
export var blink = "_gx-8";
export var dropDownSelector = "_gx-4";
export var dropDownWrapper = "_gx-3";
export var fakeCursor = "_gx-6";
export var fontSizeButton = "_gx-9";
export var formQuillEditor = "_gx-0";
export var pressed = "_gx-a";
export var qlBlank = "_gx-1";
export var textFormattingToolbar = "_gx-2";
export var textToolbarOption = "_gx-5";